import AddRoundedIcon from "@mui/icons-material/AddRounded"
import Grid from "@mui/material/Grid"
import { useTheme } from "@mui/material/styles"
import { forwardRef } from "react"
import { buildIntroOutroBackground } from "../../../../../helpers/timeline.helpers"
import { useAnimationActions } from "../../../../../hooks/useAnimationActions"
import { useAppSelector } from "../../../../../hooks/useRedux"
import { useMasterTimeline } from "../../../../../hooks/useMasterTimeline"
import RightClickContextMenu from "../../../../common/ContextMenu/RightClickContextMenu"

interface Props {
    objectId: string
    index: number
    TimelineTimeStepWidth: number
    timelineStepX: number
}

const TimelineTimeStep = forwardRef<HTMLDivElement, Props>(
    ({ objectId, index, TimelineTimeStepWidth, timelineStepX }, ref) => {
        const theme = useTheme()
        const { addNewAnimation } = useAnimationActions()
        const { effectiveTimelineDuration } = useMasterTimeline()
        const timeline = useAppSelector((state) => state.timeline.value)
        const handleCreateTween = () => addNewAnimation(objectId, index)

        const timeStepFromTime = index
        const timeStepToTime = index + 1
        const baseColor = theme.palette.background.paper

        const background = buildIntroOutroBackground(
            TimelineTimeStepWidth,
            baseColor,
            timeline.introEnd,
            timeline.outroStart,
            effectiveTimelineDuration,
            timeStepFromTime,
            timeStepToTime,
            theme
        )

        return (
            <Grid
                ref={ref}
                // see the note in TimeStamp: per-cell values in `style`, not `sx`
                sx={{ position: "absolute", height: "100%", cursor: "pointer" }}
                style={{
                    left: index * timelineStepX + 2 + "px",
                    width: TimelineTimeStepWidth + "px",
                    background,
                }}
            >
                <RightClickContextMenu
                    menuLabel={
                        <Grid sx={{ height: "100%", color: theme.palette.background.paper }}>
                            .
                        </Grid>
                    }
                    // a function: keeps the icon element out of every render of every step
                    data={() => [
                        {
                            icon: <AddRoundedIcon />,
                            title: "Add animation",
                            onClick: handleCreateTween,
                        },
                    ]}
                />
            </Grid>
        )
    }
)

export default TimelineTimeStep
